import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Props = { extraClass?: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'Background',
  props: {
    extraClass: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-background", _ctx.extraClass])
  }, null, 2 /* CLASS */))
}
}

})